module.exports = __webpack_public_path__ + "img/offers.c573c75c.svg";